@if (!acting && !minTimeout) {
  <span class="fake-link" (click)="act()">
  <ng-content></ng-content>
</span>
} @else {
  <app-loading [inline]="true"></app-loading>
}
